import ActionPanel from '../components/ActionPanel.jsx';
import { LockIcon } from '../components/icons.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { PASSKEYS_PATH, PROPERTY_PATH } from '../navigation/paths.js';

// The Account page — the web counterpart of the app's AccountMenu (screens/
// Account/Settings/AccountMenu.js), reached from the menu drawer. Account-level,
// so it lives at a bare /account and its back link goes to the Property landing.
// Only Passkeys is here so far: the app's other account settings (user details,
// change password, property details, delete account) have no web form yet.
export default function AccountScreen() {
  return (
    <main className="app-shell screen account-screen">
      <ScreenHeader
        title="Account"
        sub="Manage account settings"
        backTo={PROPERTY_PATH}
        backLabel="Property"
      />
      <nav className="action-panel-list" aria-label="Account settings">
        <ActionPanel
          to={PASSKEYS_PATH}
          icon={<LockIcon />}
          title="Passkeys"
          sub="Sign in without your password"
        />
      </nav>
    </main>
  );
}
